import {
  consultationBudgets,
  consultationProjectTypes,
  consultationServices,
  consultationTimelines
} from '../../assets/consultationOptions';
import { FormField } from './FormField';

export function StepProjectDetails({ register, errors }) {
  return (
    <div className="booking-step">
      <div className="booking-step__intro">
        <p className="eyebrow">Step 1</p>
        <h3>Project Details</h3>
        <p>Tell us what you need so we can prepare a focused consultation.</p>
      </div>

      <div className="booking-grid">
        <FormField id="service" label="Service Selection" required error={errors.service?.message}>
          {({ id, describedBy, invalid }) => (
            <select
              id={id}
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('service')}
            >
              <option value="">Select a service</option>
              {consultationServices.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          )}
        </FormField>

        <FormField id="projectType" label="Project Type" required error={errors.projectType?.message}>
          {({ id, describedBy, invalid }) => (
            <select
              id={id}
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('projectType')}
            >
              <option value="">Select project type</option>
              {consultationProjectTypes.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          )}
        </FormField>

        <FormField id="budget" label="Estimated Budget" required error={errors.budget?.message}>
          {({ id, describedBy, invalid }) => (
            <select
              id={id}
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('budget')}
            >
              <option value="">Select budget range</option>
              {consultationBudgets.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          )}
        </FormField>

        <FormField id="timeline" label="Timeline" required error={errors.timeline?.message}>
          {({ id, describedBy, invalid }) => (
            <select
              id={id}
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('timeline')}
            >
              <option value="">Select timeline</option>
              {consultationTimelines.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          )}
        </FormField>

        <FormField
          id="description"
          label="Project Description"
          required
          className="booking-field--full"
          error={errors.description?.message}
        >
          {({ id, describedBy, invalid }) => (
            <textarea
              id={id}
              rows="5"
              placeholder="Describe goals, features, audience, and anything we should know before the call."
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('description')}
            />
          )}
        </FormField>

        <FormField
          id="referenceUrl"
          label="File / Figma / Drive URL"
          className="booking-field--full"
          hint="Optional link to briefs, mockups, or reference files"
          error={errors.referenceUrl?.message}
        >
          {({ id, describedBy, invalid }) => (
            <input
              id={id}
              type="url"
              placeholder="https://figma.com/file/... or Drive link"
              aria-invalid={invalid}
              aria-describedby={describedBy}
              {...register('referenceUrl')}
            />
          )}
        </FormField>
      </div>
    </div>
  );
}
